import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './ServiceWizard.css'

const FAMILY_PRESETS = {
	boulangerie:  ['Pains', 'Viennoiseries', 'Pâtisseries', 'Boissons'],
	epicerie:     ['Fruits & Légumes', 'Produits frais', 'Boissons', 'Snacks', 'Épicerie'],
	restauration: ['Entrées', 'Plats', 'Desserts', 'Boissons'],
	boutique:     ['Vêtements', 'Équipement', 'Souvenirs', 'Accessoires'],
}
const PRESET_LABELS = { boulangerie: 'Boulangerie', epicerie: 'Épicerie', restauration: 'Restauration', boutique: 'Boutique' }
const MAX_FAMILIES = 8
const MAX_FAMILY_NAME = 30

function makeFamily(name, order, lang) {
	return { id: Date.now().toString(36) + Math.random().toString(36).slice(2), order, translations: [{ lang, name }] }
}

class ServiceWizard extends Component {
	constructor(props) {
		super(props)
		this.state = {
			step: 1,
			form: {
				type: '',
				name: '',
				cover: null,
				coverFile: null,
				location: '',
				limit_end_h: 2,
				limit_end_m: 0,
				cancel_limit_h: 2,
				cancel_limit_m: 0,
				dissociate: false,
				product_images: false,
				families: []
			},
			activeFamilyPreset: null,
			familyAddInput: '',
			familyAddError: null,
			familyAddShow: false,
			loading: false,
			error: null
		}
		this.props.updateNavbarTitle('Nouveau service')
	}

	handleType = (type) => {
		const extra = type === 'vente' ? { limit_end_h: 0, limit_end_m: 0, cancel_limit_h: 0, cancel_limit_m: 0 } : {}
		this.setState({ form: { ...this.state.form, type, ...extra }, step: 2, error: null })
	}

	handleCover = (e) => {
		const file = e.target.files[0]
		if (!file) return
		const reader = new FileReader()
		reader.onload = (ev) => {
			const img = new Image()
			img.onload = () => {
				const MAX_W = 1200
				const scale = img.width > MAX_W ? MAX_W / img.width : 1
				const canvas = document.createElement('canvas')
				canvas.width = Math.round(img.width * scale)
				canvas.height = Math.round(img.height * scale)
				canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height)
				const cover = canvas.toDataURL('image/jpeg', 0.75)
				canvas.toBlob(blob => {
					const jpegFile = new File([blob], 'cover.jpg', { type: 'image/jpeg' })
					this.setState({ form: { ...this.state.form, cover, coverFile: jpegFile }, error: null })
				}, 'image/jpeg', 0.75)
			}
			img.src = ev.target.result
		}
		reader.readAsDataURL(file)
	}

	handleName = (e) => {
		const val = e.target.value.slice(0, 50)
		this.setState({ form: { ...this.state.form, name: val }, error: null })
	}

	handleLocation = (e) => {
		this.setState({ form: { ...this.state.form, location: e.target.value } })
	}

	handleLimitEndH = (e) => {
		const raw = e.target.value
		this.setState({ form: { ...this.state.form, limit_end_h: raw === '' ? '' : Math.max(0, parseInt(raw) || 0) } })
	}

	handleLimitEndHBlur = () => {
		if (this.state.form.limit_end_h === '') this.setState({ form: { ...this.state.form, limit_end_h: 0 } })
	}

	handleLimitEndM = (e) => {
		const raw = e.target.value
		this.setState({ form: { ...this.state.form, limit_end_m: raw === '' ? '' : Math.min(59, Math.max(0, parseInt(raw) || 0)) } })
	}

	handleLimitEndMBlur = () => {
		if (this.state.form.limit_end_m === '') this.setState({ form: { ...this.state.form, limit_end_m: 0 } })
	}

	handleCancelLimitH = (e) => {
		const raw = e.target.value
		this.setState({ form: { ...this.state.form, cancel_limit_h: raw === '' ? '' : Math.max(0, parseInt(raw) || 0) } })
	}

	handleCancelLimitHBlur = () => {
		if (this.state.form.cancel_limit_h === '') this.setState({ form: { ...this.state.form, cancel_limit_h: 0 } })
	}

	handleCancelLimitM = (e) => {
		const raw = e.target.value
		this.setState({ form: { ...this.state.form, cancel_limit_m: raw === '' ? '' : Math.min(59, Math.max(0, parseInt(raw) || 0)) } })
	}

	handleCancelLimitMBlur = () => {
		if (this.state.form.cancel_limit_m === '') this.setState({ form: { ...this.state.form, cancel_limit_m: 0 } })
	}

	handleProductImages = () => {
		this.setState({ form: { ...this.state.form, product_images: !this.state.form.product_images } })
	}

	handleDissociate = () => {
		const { form } = this.state
		const next = !form.dissociate
		this.setState({
			form: {
				...form,
				dissociate: next,
				cancel_limit_h: next ? form.limit_end_h : form.limit_end_h,
				cancel_limit_m: next ? form.limit_end_m : form.limit_end_m
			}
		})
	}

	isStep2Valid = () => {
		const { form } = this.state
		if (!form.name.trim()) {
			this.setState({ error: 'Le nom du service est requis.' })
			return false
		}
		if (!form.cover) {
			this.setState({ error: 'Une photo est requise.' })
			return false
		}
		return true
	}

	nextStep = () => {
		if (this.state.step === 2 && !this.isStep2Valid()) return
		this.setState({ step: this.state.step + 1, error: null })
	}

	prevStep = () => {
		this.setState({ step: this.state.step - 1, error: null })
	}

	handleFamilyPreset = (key) => {
		const { activeFamilyPreset } = this.state
		const lang = this.props.lang_default
		if (activeFamilyPreset === key) {
			this.setState({ activeFamilyPreset: null, form: { ...this.state.form, families: [] } })
			return
		}
		const names = FAMILY_PRESETS[key]
		const families = names.map((name, i) => makeFamily(name, i, lang))
		this.setState({ activeFamilyPreset: key, form: { ...this.state.form, families } })
	}

	removeFamilyWizard = (id) => {
		const families = this.state.form.families.filter(f => f.id !== id).map((f, i) => ({ ...f, order: i }))
		this.setState({ form: { ...this.state.form, families }, activeFamilyPreset: null })
	}

	handleFamilyAddInput = (e) => {
		const val = e.target.value
		this.setState({ familyAddInput: val.slice(0, MAX_FAMILY_NAME), familyAddError: null })
	}

	submitFamilyAdd = () => {
		const { familyAddInput, form } = this.state
		const name = familyAddInput.trim()
		if (!name) { this.setState({ familyAddInput: '', familyAddShow: false }); return }
		const lang = this.props.lang_default
		const dup = form.families.some(f => {
			const t = (f.translations || []).find(t => t.lang === lang)
			return t && t.name.trim().toLowerCase() === name.toLowerCase()
		})
		if (dup) { this.setState({ familyAddError: 'Cette famille existe déjà.' }); return }
		if (form.families.length >= MAX_FAMILIES) return
		const newFamily = makeFamily(name, form.families.length, lang)
		this.setState({
			form: { ...form, families: [...form.families, newFamily] },
			familyAddInput: '',
			familyAddShow: false,
			familyAddError: null,
			activeFamilyPreset: null
		})
	}

	handleSubmit = () => {
		this.setState({ loading: true, error: null })
		const { form } = this.state

		const uploadCover = form.coverFile
			? (() => {
				const fd = new FormData()
				fd.append('file', form.coverFile)
				return this.props.insertPicture(fd)
			})()
			: Promise.resolve(null)

		uploadCover
			.then(() => {
				const url = form.name.toLowerCase()
					.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
					.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
				const translations = this.props.langs.map(lang => ({ lang, title: form.name, url, location: form.location || '' }))
				const service = {
					name: form.name,
					cover: form.cover,
					type: form.type,
					translations,
					comment: null,
					list_mode: false,
					product_images: form.product_images,
					families: form.families || [],
					user: this.props.user._id
				}
				return this.props.insertService(service)
			})
			.then(newService => {
				const durationPayload = {
					id: newService._id,
					open_dates: [],
					open_hours: [],
					duration_hour: 0,
					duration_minute: 0,
					interval_hour: 0,
					interval_minute: 0,
					limit_end: form.type === 'vente' ? 0 : form.limit_end_h + form.limit_end_m / 60,
					cancel_limit: form.type === 'vente' ? 0 : form.cancel_limit_h + form.cancel_limit_m / 60,
					translations: newService.translations
				}
				return this.props.updateServiceDuration(durationPayload)
					.then(() => newService)
			})
			.then(newService => {
				this.props.history.push('/services/' + newService._id, { openBenefitWizard: true, serviceTitle: form.name })
			})
			.catch(() => {
				this.setState({ loading: false, error: "Une erreur s'est produite. Veuillez réessayer." })
			})
	}

	renderProgressBar = () => {
		const { step } = this.state
		const steps = ['Type', 'Infos', 'Récap']
		return (
			<div className="flex items-center justify-center gap-2 py-6 px-6">
				{steps.map((label, i) => {
					const n = i + 1
					const active = n === step
					const done = n < step
					return (
						<React.Fragment key={n}>
							{i > 0 && (
								<div className={`h-0.5 w-8 flex-shrink-0 ${done ? 'bg-indigo-600' : 'bg-gray-200'}`} />
							)}
							<div className="flex flex-col items-center gap-1">
								<div className={`w-8 h-8 rounded-full flex items-center justify-center text-base font-semibold flex-shrink-0
									${active ? 'bg-indigo-600 text-white' : done ? 'bg-indigo-100 text-indigo-600' : 'bg-gray-100 text-gray-400'}`}>
									{done ? '✓' : n}
								</div>
								<span className={`text-base hidden sm:block ${active ? 'text-indigo-600 font-medium' : 'text-gray-400'}`}>
									{label}
								</span>
							</div>
						</React.Fragment>
					)
				})}
			</div>
		)
	}

	renderStep1 = () => {
		const types = [
			{
				key: 'prestation',
				icon: '🎯',
				title: 'Activité ou événement',
				desc: 'Inscriptions sur des créneaux horaires avec nombre de places limité.',
				examples: 'Yoga, aquagym, soirée repas, table de restaurant...'
			},
			{
				key: 'vente',
				icon: '🛒',
				title: 'Commande',
				desc: 'Les clients choisissent des articles dans un catalogue.',
				examples: 'Boulangerie, panier repas, petit-déjeuner...'
			}
		]

		return (
			<div>
				<h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">Quel type de service ?</h2>
				<p className="text-gray-500 text-center mb-8">Choisissez le type qui correspond à votre service.</p>
				<div className="flex flex-col gap-4">
					{types.map(t => {
						const isDisabled = false
						return (
							<button
								key={t.key}
								type="button"
								onClick={() => !isDisabled && this.handleType(t.key)}
								disabled={isDisabled}
								title={isDisabled ? 'Fonctionnalité en cours de développement' : undefined}
								className={`text-left border-2 rounded-2xl p-6 transition-all focus:outline-none ${isDisabled ? 'border-gray-100 bg-gray-50 opacity-50 cursor-not-allowed' : 'border-gray-200 cursor-pointer hover:border-indigo-500 hover:shadow-md focus:border-indigo-500 bg-white'}`}
							>
								<div className="flex items-start gap-4">
									<span className="text-4xl">{t.icon}</span>
									<div>
										<p className="text-lg font-bold text-gray-900 mb-1">{t.title}</p>
										<p className="text-base text-gray-600 mb-1">{t.desc}</p>
										<p className="text-base text-gray-400">{t.examples}</p>
									</div>
								</div>
							</button>
						)
					})}
				</div>
			</div>
		)
	}

	renderStep2 = () => {
		const { form, error } = this.state
		const isPrestation = form.type === 'prestation'

		return (
			<div>
				<h2 className="text-2xl font-bold text-gray-900 mb-2">L'essentiel</h2>
				<p className="text-gray-500 mb-8">Ces informations seront visibles par vos campeurs.</p>

				{/* Photo */}
				<div className="mb-6">
					<label className="block text-base font-medium text-gray-700 mb-2">Photo du service</label>
					{form.cover ? (
						<div className="relative">
							<img src={form.cover} alt="aperçu" className="w-full h-48 object-cover rounded-xl" />
							<button
								type="button"
								onClick={() => this.setState({ form: { ...form, cover: null, coverFile: null } })}
								className="absolute top-2 right-2 bg-white rounded-full w-7 h-7 flex items-center justify-center shadow text-gray-600 hover:text-red-500 text-base font-bold"
							>✕</button>
						</div>
					) : (
						<label className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-xl cursor-pointer hover:border-indigo-400 hover:bg-indigo-50 transition-colors">
							<span className="text-3xl mb-2" role="img" aria-label="Photo">📷</span>
							<span className="text-base text-gray-500">Cliquez pour ajouter une photo</span>
							<span className="text-base text-gray-400 mt-1">JPG, PNG, GIF</span>
							<input type="file" accept="image/*" onChange={this.handleCover} className="hidden" />
						</label>
					)}
				</div>

				{/* Nom */}
				<div className="mb-6">
					<label className="block text-base font-medium text-gray-700 mb-2">
						Nom du service <span className="text-gray-400 font-normal">({form.name.length}/50)</span>
					</label>
					<input
						type="text"
						value={form.name}
						onChange={this.handleName}
						placeholder="ex : Cours de yoga du matin"
						className="w-full border border-gray-300 rounded-xl px-4 py-3 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
					/>
					<p className="text-base text-gray-400 mt-1">
						Ce nom sera utilisé dans toutes les langues jusqu'à ce que vous ajoutiez des traductions.
					</p>
				</div>

				{/* Lieu de retrait (vente uniquement) */}
				{!isPrestation && (
					<div className="mb-6">
						<label className="block text-base font-medium text-gray-700 mb-1">
							Lieu de retrait
						</label>
						<p className="text-base text-gray-400 mb-3">
							Où les campeurs récupèrent leur commande. (ex : Réception, Bar, Accueil bâtiment A...)
						</p>
						<input
							type="text"
							value={form.location}
							onChange={this.handleLocation}
							placeholder="ex : Réception"
							className="w-full border border-gray-300 rounded-xl px-4 py-3 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
						/>
					</div>
				)}

				{/* Photos des articles (vente uniquement) */}
				{!isPrestation && (
					<div className="mb-6">
						<div className="flex items-center justify-between mb-1">
							<label className="block text-base font-medium text-gray-700">Photos des articles</label>
							<button
								type="button"
								onClick={this.handleProductImages}
								style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
							>
								<span style={{ display: 'inline-flex', width: '44px', height: '24px', borderRadius: '12px', background: form.product_images ? '#4f46e5' : '#d1d5db', alignItems: 'center', padding: '2px', transition: 'background 0.2s' }}>
									<span style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'white', transform: form.product_images ? 'translateX(20px)' : 'translateX(0)', transition: 'transform 0.2s' }} />
								</span>
							</button>
						</div>
						<p className="text-base text-gray-400">
							Afficher une photo illustrative sur chaque article du catalogue.
						</p>
					</div>
				)}

				{/* Familles de produits (vente uniquement) */}
				{!isPrestation && (
					<div className="mb-6">
						<div className="flex items-center justify-between mb-1">
							<label className="block text-base font-medium text-gray-700">Familles de produits</label>
							{form.families.length > 0 && (
								<span className="text-sm text-gray-400">{form.families.length}/{MAX_FAMILIES}</span>
							)}
						</div>
						<p className="text-base text-gray-400 mb-3">Regroupez vos articles par catégorie (ex : Pains, Boissons...).</p>
						<div className="flex flex-wrap gap-2 mb-3">
							{Object.keys(FAMILY_PRESETS).map(key => (
								<button key={key} type="button"
									onClick={() => this.handleFamilyPreset(key)}
									style={{ backgroundImage: 'none', backgroundColor: this.state.activeFamilyPreset === key ? '#eef2ff' : '#f9fafb', border: `1px solid ${this.state.activeFamilyPreset === key ? '#6366f1' : '#e5e7eb'}`, color: this.state.activeFamilyPreset === key ? '#4f46e5' : '#374151', borderRadius: '9999px', padding: '4px 14px', fontSize: '0.9rem', fontWeight: this.state.activeFamilyPreset === key ? 600 : 400, transition: 'all 0.15s' }}>
									{PRESET_LABELS[key]}
								</button>
							))}
						</div>
						{form.families.length > 0 && (
							<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
								{form.families.map(f => {
									const t = (f.translations || [])[0] || {}
									return (
										<span key={f.id} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: '9999px', padding: '4px 12px', fontSize: '0.9rem', color: '#111827' }}>
											{t.name}
											<button type="button" onClick={() => this.removeFamilyWizard(f.id)} style={{ backgroundImage: 'none', backgroundColor: 'transparent', color: '#9ca3af', fontWeight: 700, lineHeight: 1, padding: '0 2px', fontSize: '1rem' }}>×</button>
										</span>
									)
								})}
							</div>
						)}
						{this.state.familyAddShow ? (
							<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
								<div style={{ position: 'relative', flex: 1 }}>
									<input
										autoFocus
										type="text"
										value={this.state.familyAddInput}
										onChange={this.handleFamilyAddInput}
										onKeyDown={e => { if (e.key === 'Enter') this.submitFamilyAdd(); if (e.key === 'Escape') this.setState({ familyAddShow: false, familyAddInput: '', familyAddError: null }) }}
										placeholder="Nom de la famille"
										maxLength={MAX_FAMILY_NAME}
										className="w-full border border-indigo-400 rounded-xl px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
									/>
									<span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.75rem', color: '#9ca3af' }}>{this.state.familyAddInput.length}/{MAX_FAMILY_NAME}</span>
								</div>
								<button type="button" onClick={this.submitFamilyAdd} style={{ backgroundImage: 'none', backgroundColor: '#4f46e5', color: 'white', borderRadius: '10px', padding: '8px 14px', fontSize: '0.9rem', fontWeight: 600 }}>OK</button>
								<button type="button" onClick={() => this.setState({ familyAddShow: false, familyAddInput: '', familyAddError: null })} style={{ backgroundImage: 'none', backgroundColor: 'transparent', color: '#9ca3af', fontSize: '1.1rem' }}>×</button>
							</div>
						) : (
							<button type="button"
								onClick={() => form.families.length < MAX_FAMILIES && this.setState({ familyAddShow: true })}
								disabled={form.families.length >= MAX_FAMILIES}
								style={{ backgroundImage: 'none', backgroundColor: 'transparent', color: form.families.length >= MAX_FAMILIES ? '#d1d5db' : '#6366f1', fontSize: '0.9rem', fontWeight: 500 }}>
								{form.families.length >= MAX_FAMILIES ? `Limite atteinte (${MAX_FAMILIES}/${MAX_FAMILIES})` : '+ Ajouter une famille'}
							</button>
						)}
						{this.state.familyAddError && <p style={{ color: '#ef4444', fontSize: '0.85rem', marginTop: '4px' }}>{this.state.familyAddError}</p>}
					</div>
				)}

				{/* Fermeture des inscriptions */}
				{isPrestation && <div className="mb-6">
					<label className="block text-base font-medium text-gray-700 mb-1">
						Fermeture des inscriptions
					</label>
					<p className="text-base text-gray-400 mb-3">
						Les nouvelles inscriptions se ferment X heures avant le début.
					</p>
					<div className="flex items-center gap-2">
						<input
							type="number"
							min="0"
							value={form.limit_end_h}
							onChange={this.handleLimitEndH}
						onBlur={this.handleLimitEndHBlur}
							className="w-20 border border-gray-300 rounded-xl px-3 py-3 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
						/>
						<span className="text-base text-gray-500">h</span>
						<input
							type="number"
							min="0"
							max="59"
							value={form.limit_end_m}
							onChange={this.handleLimitEndM}
						onBlur={this.handleLimitEndMBlur}
							className="w-20 border border-gray-300 rounded-xl px-3 py-3 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
						/>
						<span className="text-base text-gray-500">min avant</span>
					</div>
				</div>}

				{/* Délai d'annulation */}
				{isPrestation && (
					<div className="mb-6">
						<label className="block text-base font-medium text-gray-700 mb-1">
							Délai d'annulation
						</label>
						<p className="text-base text-gray-400 mb-3">
							Les participants peuvent annuler leur inscription jusqu'à X heures avant le début.
						</p>
						<div className="flex items-center gap-2">
							<input
								type="number"
								min="0"
								value={form.cancel_limit_h}
								onChange={this.handleCancelLimitH}
								onBlur={this.handleCancelLimitHBlur}
								className="w-20 border border-gray-300 rounded-xl px-3 py-3 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
							/>
							<span className="text-base text-gray-500">h</span>
							<input
								type="number"
								min="0"
								max="59"
								value={form.cancel_limit_m}
								onChange={this.handleCancelLimitM}
								onBlur={this.handleCancelLimitMBlur}
								className="w-20 border border-gray-300 rounded-xl px-3 py-3 text-center text-base font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
							/>
							<span className="text-base text-gray-500">min avant</span>
						</div>
					</div>
				)}

				{/* Info message */}
				<div className="rounded-xl bg-blue-50 border border-blue-100 px-4 py-3 mb-6 text-base text-blue-700">
					<span role="img" aria-label="Info">💡</span> {isPrestation
						? "Vous configurerez les créneaux disponibles, le nombre de places et les périodes d'ouverture depuis la fiche du service."
						: "Vous ajouterez les produits et les créneaux de retrait depuis la fiche du service."}
				</div>

				{error && (
					<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-4 text-base text-red-700">
						{error}
					</div>
				)}

				<div className="flex gap-3 mt-8">
					<button type="button" onClick={this.prevStep}
						className="flex-1 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors">
						← Retour
					</button>
					<button type="button" onClick={this.nextStep}
						className="flex-1 py-3 rounded-xl bg-indigo-600 text-white font-medium hover:bg-indigo-700 transition-colors">
						Suivant →
					</button>
				</div>
			</div>
		)
	}

	renderStep3 = () => {
		const { form, loading, error } = this.state
		const isPrestation = form.type === 'prestation'
		const typeLabel = isPrestation ? 'Activité ou événement' : 'Commande'
		const typeIcon = isPrestation ? '🎯' : '🛒'

		return (
			<div>
				<h2 className="text-2xl font-bold text-gray-900 mb-2">Récapitulatif</h2>
				<p className="text-gray-500 mb-8">Vérifiez les informations avant de créer le service.</p>

				<div className="rounded-2xl border border-gray-200 overflow-hidden mb-6 bg-white">
					{form.cover && (
						<img src={form.cover} alt="cover" className="w-full h-40 object-cover" />
					)}
					<div className="p-5">
						<span className="inline-flex items-center gap-1.5 text-base font-semibold px-3 py-1 rounded-full bg-indigo-100 text-indigo-700 mb-3">
							{typeIcon} {typeLabel}
						</span>
						<p className="text-xl font-bold text-gray-900 mb-4">{form.name}</p>
						<div className="space-y-2 text-base">
							{!isPrestation && form.location && (
								<div className="flex justify-between">
									<span className="text-gray-400">Lieu de retrait</span>
									<span className="font-medium text-gray-700">{form.location}</span>
								</div>
							)}
							{isPrestation && (
								<>
									<div className="flex justify-between">
										<span className="text-gray-400">Fermeture des inscriptions</span>
										<span className="font-medium text-gray-700">{form.limit_end_h}h {String(form.limit_end_m).padStart(2, '0')}min avant</span>
									</div>
									{form.dissociate && (
										<div className="flex justify-between">
											<span className="text-gray-400">Délai d'annulation</span>
											<span className="font-medium text-gray-700">{form.cancel_limit_h}h {String(form.cancel_limit_m).padStart(2, '0')}min avant</span>
										</div>
									)}
								</>
							)}
						</div>
					</div>
				</div>

				{error && (
					<div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 mb-4 text-base text-red-700">
						{error}
					</div>
				)}

				<div className="flex gap-3">
					<button type="button" onClick={this.prevStep} disabled={loading}
						className="flex-1 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors disabled:opacity-50">
						← Retour
					</button>
					<button type="button" onClick={this.handleSubmit} disabled={loading}
						className="flex-1 py-3 rounded-xl bg-indigo-600 text-white font-bold hover:bg-indigo-700 transition-colors disabled:opacity-70 flex items-center justify-center gap-2">
						{loading ? (
							<>
								<svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
									<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
									<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
								</svg>
								Création...
							</>
						) : 'Créer le service'}
					</button>
				</div>
			</div>
		)
	}

	render() {
		const { step } = this.state
		return (
			<div className="min-h-screen bg-gray-100 py-8 px-4">
				<div className="max-w-xl mx-auto">
					{/* Back link */}
					<Link to="/services" className="inline-flex items-center gap-2 text-base text-gray-500 hover:text-gray-800 transition-colors mb-6">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
							<path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
						</svg>
						Retour aux services
					</Link>

					{/* Carte principale */}
					<div className="wizard-card bg-white rounded-2xl shadow-sm overflow-hidden">
						{this.renderProgressBar()}
						<div className="border-t border-gray-100" />
						<div className="p-6 pb-8">
							{step === 1 && this.renderStep1()}
							{step === 2 && this.renderStep2()}
							{step === 3 && this.renderStep3()}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ServiceWizard
